import React from "react";

const RankingTooltipTrigger = ({ onShow, onHide }) => {
  return (
    <button
      onFocus={onShow}
      onBlur={onHide}
      className="btn-ranking__tooltip-trigger"
    >
      i
    </button>
  );
};

export default RankingTooltipTrigger;
